import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { generateTarget } from '../Common/Helpers/UrlHelper';

export default class BannerItem extends Component {
  render() {
    return (
      <div
        className='banner-carousel__images'
        data-dot={
          `
          <div class="banner-carousel__link">
            ${this.props.heading}
            <br>
            ${this.props.caption}
          </div>
          `
        }
      >
        <a href={this.props.landingPageUrl} aria-label="Landing Page Url" target={generateTarget(this.props.landingPageUrl)}>
          <span
            className='banner-carousel__image banner-carousel__image--mobile lazyload'
            data-bg={this.props.mobileImage}
          >
          </span>
          <span
            className='banner-carousel__image banner-carousel__image--non-mobile lazyload'
            data-bg={this.props.nonMobileImage}
          >
          </span>
        </a>
      </div>
    );
  }
}

BannerItem.propTypes = {
  heading: PropTypes.string.isRequired,
  caption: PropTypes.string.isRequired,
  mobileImage: PropTypes.string.isRequired,
  nonMobileImage: PropTypes.string.isRequired,
  landingPageUrl: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/Carousel/BannerItem.js